import moment from "moment";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../../components/Box";
import CustomNumberInput from "../../../../components/CustomNumberInput";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { Helpers } from "../../../../helpers/Helpers";
import { GetAgreementByIdResponse } from "../../../../models/response/agreement/GetAgreementByIdResponse";
import { storeActivityIndicator, storeAreYouSureModalCallback } from "../../../../redux/reducers/authSlice";
import { AgreementService } from "../../../../services/AgreementService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { InOutListModelDetailModel } from "../CalculateList";
import toast from "react-hot-toast";
import { GetAgreementListResponseDaum } from "../../../../models/response/agreement/GetAgreementListResponse";
import CustomMultiSelect, { CustomMultiSelectModel } from "../../../../components/CustomMultiSelect";

interface Props {
    inOutDetailList: InOutListModelDetailModel[]
    setInOutDetailList: React.Dispatch<React.SetStateAction<InOutListModelDetailModel[]>>
    selectedDate: string
    setSelectedDate: React.Dispatch<React.SetStateAction<string>>
    selectedAgreements: CustomMultiSelectModel[]
    setSelectedAgreements: React.Dispatch<React.SetStateAction<CustomMultiSelectModel[]>>
    isIn: boolean
    isOut: boolean
    selectedCurrencyType: CustomSingleSelectModel | undefined
    setSelectedCurrencyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    agreementList: CustomSingleSelectModel[]
    onAgreementChange: (selectedValues: CustomMultiSelectModel[]) => Promise<void>
    currencyTypes: CustomSingleSelectModel[]
}

const ProductInformation = ({
    inOutDetailList,
    setInOutDetailList,
    selectedDate,
    setSelectedDate,
    selectedAgreements,
    setSelectedAgreements,
    isIn,
    isOut,
    selectedCurrencyType,
    setSelectedCurrencyType,
    agreementList,
    onAgreementChange,
    currencyTypes
}: Props) => {
    const dispatch = useDispatch();

    const deleteItems = () => {
        setInOutDetailList(inOutDetailList.filter(x => !x.isSelected));
    }

    const selectAll = () => {
        var isAllSelected = inOutDetailList.length == inOutDetailList.filter(x => x.isSelected).length;

        setInOutDetailList(inOutDetailList.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setItemSelected = (_id: string) => {
        setInOutDetailList(inOutDetailList.map(function (x) {
            if (x.entityId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const changePotQuantity = (_entityId: string, _value: string) => {
        setInOutDetailList(inOutDetailList.map(function (x) {
            if (x.entityId == _entityId)
                x.processPotQuantity = _value;

            return x;
        }))
    }

    const changeGrossWeight = (_entityId: string, _value: string) => {
        setInOutDetailList(inOutDetailList.map(function (x) {
            if (x.entityId == _entityId)
                x.processGrossWeight = _value;

            return x;
        }))
    }

    const changeVolume = (_entityId: string, _value: string) => {
        setInOutDetailList(inOutDetailList.map(function (x) {
            if (x.entityId == _entityId)
                x.processVolume = _value;

            return x;
        }))
    }

    const changeArea = (_entityId: string, _value: string) => {
        setInOutDetailList(inOutDetailList.map(function (x) {
            if (x.entityId == _entityId)
                x.processArea = _value;

            return x;
        }))
    }

    return (
        <div className='containerPart' /*ref={vehicleInformationRef}*/>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <Box className="mb-10" flexDirection="row">
                        <Box flexGrow={1} justifyContent='center'>
                            <h4 className="text-black">Çıkış Hesaplama Bilgileri</h4>
                        </Box>
                        {
                            isIn && (
                                <Box flexDirection="row" justifyContent='center'>
                                    <Box mr="10px" justifyContent='center'>
                                        <label htmlFor="exampleFormControlInput1" className="m-0 form-label required">Antrepo Çıkış Tarihi</label>
                                    </Box>
                                    <Box width="250px" justifyContent='center'>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={selectedDate} onChange={(e) => { setSelectedDate(e.target.value); }} type="date" className="form-control form-control-solid" />
                                    </Box>
                                </Box>
                            )
                        }
                        <Box ml="20px" flexDirection="row" justifyContent='center'>
                            <Box mr="10px" justifyContent='center'>
                                <label htmlFor="exampleFormControlInput1" className="m-0 form-label required">Anlaşma Adı</label>
                            </Box>
                            <Box width="500px" justifyContent='center'>
                                <CustomMultiSelect
                                    selectedValues={selectedAgreements}
                                    onChange={onAgreementChange}
                                    onMenuOpen={async () => {
                                        return {
                                            isSuccess: true,
                                            data: agreementList
                                        }
                                    }}
                                    labelName='label'
                                    valueName='value'
                                    additionalValue1Name="additionalValue1"
                                />
                            </Box>
                        </Box>

                        {
                            (selectedAgreements.length > 0 && currencyTypes.length > 0) && (
                                <Box ml="20px" flexDirection="row" justifyContent='center'>
                                    <Box mr="10px" justifyContent='center'>
                                        <label htmlFor="exampleFormControlInput1" className="m-0 form-label required">Para Birimi</label>
                                    </Box>
                                    <Box width="200px" justifyContent='center'>
                                        <CustomSingleSelect
                                            selectedValue={selectedCurrencyType}
                                            onChange={setSelectedCurrencyType}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: currencyTypes
                                                }
                                            }}
                                            labelName='label'
                                            valueName='value'
                                        />
                                    </Box>
                                </Box>
                            )
                        }
                    </Box>

                    <Box className={"mt-5"} flexDirection="row">
                        <Box onClick={inOutDetailList.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={inOutDetailList.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className="table-responsive">
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={inOutDetailList.filter(x => x.isSelected).length > 0 && inOutDetailList.filter(x => x.isSelected).length == inOutDetailList.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Defter No</th>
                                            <th>Ürün Cinsi</th>
                                            <th>Kap Cinsi</th>
                                            <th>Çıkan Kap</th>
                                            <th>Çıkan Brüt Ağırlık</th>
                                            <th>Çıkan M3</th>
                                            <th>Çıkan M2</th>
                                            <th>Stok Kap</th>
                                            <th>Stok Brüt Ağırlık</th>
                                            <th>Stok M3</th>
                                            <th>Stok M2</th>
                                            <th>Hesaplanan Gün</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            inOutDetailList.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            inOutDetailList.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                <input onChange={() => setItemSelected(item.entityId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.ledgerNo}</td>
                                                    <td>{item.productKindName}</td>
                                                    <td>{item.potTypeName}</td>
                                                    {isOut && <td>{item.processPotQuantity}</td>}
                                                    {isOut && <td>{item.processGrossWeight}</td>}
                                                    {isOut && <td>{item.processVolume}</td>}
                                                    {isOut && <td>{item.processArea}</td>}
                                                    {isIn && <td><CustomNumberInput setValue={(value: string) => changePotQuantity(item.entityId, value)} value={item.processPotQuantity} /></td>}
                                                    {isIn && <td><CustomNumberInput setValue={(value: string) => changeGrossWeight(item.entityId, value)} value={item.processGrossWeight} /></td>}
                                                    {isIn && <td><CustomNumberInput setValue={(value: string) => changeVolume(item.entityId, value)} value={item.processVolume} /></td>}
                                                    {isIn && <td><CustomNumberInput setValue={(value: string) => changeArea(item.entityId, value)} value={item.processArea} /></td>}
                                                    <td>{item.stockPotQuantity}</td>
                                                    <td>{item.stockGrossWeight}</td>
                                                    <td>{item.stockVolume}</td>
                                                    <td>{item.stockArea}</td>

                                                    {
                                                        isIn && (
                                                            <React.Fragment>
                                                                {
                                                                    !Helpers.isEmpty(selectedDate) ?
                                                                        (
                                                                            <td>{selectedDate.split('T')[0].split(' ')[0] == item.startDate?.split('T')[0].split(' ')[0] ? 0 : Math.ceil(moment.duration(moment(selectedDate).diff(moment(item.startDate))).asDays() + 1)}</td>
                                                                        )
                                                                        :
                                                                        (
                                                                            <td></td>
                                                                        )
                                                                }
                                                            </React.Fragment>
                                                        )
                                                    }

                                                    {
                                                        isOut && (
                                                            <td>{item.endDate?.split('T')[0].split(' ')[0] == item.startDate?.split('T')[0].split(' ')[0] ? 0 : Math.ceil(moment.duration(moment(item.endDate?.split('T')[0].split(' ')[0]).diff(moment(item.startDate?.split('T')[0].split(' ')[0]))).asDays()) + 1}</td>
                                                        )
                                                    }
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default ProductInformation;